module.exports = __webpack_public_path__ + "media/27_Long.0fb19792.mp3";